import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import './styles.scss';
const Switch = ({ switchClass, switchCallback, activeSwitch, switchColor }) => {
	const [switchActive, setSwitchActive] = useState(false);

	useEffect(() => {
		setSwitchActive(activeSwitch);
	}, [activeSwitch]);

	return (
		<div
			className={cx(
				!switchActive ? 'bg-light-grey' : switchColor === 'green' ? 'bg-12pc-light' : 'bg-blue',
				'switch pos-rel',
				switchClass,
			)}
			onClick={() => {
				setSwitchActive(!switchActive);
				switchCallback(!switchActive);
			}}>
			<div
				className={cx(
					switchActive ? 'active' : 'not-active',
					!switchActive
						? 'bg-white'
						: switchColor === 'green'
						? 'bg-12pc-green'
						: switchColor === 'primary'
						? 'bg-merchant-blue'
						: 'bg-dark-blue',
				)}></div>
		</div>
	);
};
export default Switch;
